<template>
  <div id="traffic-modal">
    <div class="modal">
      <div class="close" @click="close">
        <v-icon>mdi-close-circle-outline</v-icon>
        <span>닫기</span>
      </div>
      <div class="title d-flex">
        <img src="@/assets/icons/obituary/bus-icon.svg" alt="버스 아이콘" />
        <h4 class="ml-2">교통안내</h4>
      </div>
      <div v-if="address" class="address">
        <h5>{{ address.name }}</h5>
        <p>{{ address.address }}</p>
        <div class="call">
          <img src="@/assets/icons/obituary/phone.svg" alt="phoneIcon" />
          <span>{{ address.phone }}</span>
        </div>
      </div>
      <div>
        <nav>
          <ul>
            <li
              class="ml-0"
              @click="type = 'bus'"
              :class="{ active: type === 'bus' }"
            >
              버스
            </li>
            <li @click="type = 'subway'" :class="{ active: type === 'subway' }">
              지하철
            </li>
            <li
              @click="type = 'parking'"
              :class="{ active: type === 'parking' }"
            >
              주차안내
            </li>
          </ul>
        </nav>
      </div>
      <div v-if="address" class="content">
        <div v-if="type === 'bus'">
          <div v-if="address.bus" v-html="address.bus"></div>
          <div v-else>ㆍ 안내 정보가 제공되지 않습니다</div>
        </div>
        <div v-else-if="type === 'subway'">
          <div v-if="address.subway" v-html="address.subway"></div>
          <div v-else>ㆍ 안내 정보가 제공되지 않습니다</div>
        </div>
        <div v-else-if="type === 'parking'">
          <div v-if="address.parking" v-html="address.parking"></div>
          <div v-else>ㆍ 안내 정보가 제공되지 않습니다</div>
        </div>
      </div>
      <div v-else>
        <div>
          <div>ㆍ 안내 정보가 제공되지 않습니다</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    address: {
      type: Object,
      default: Object
    },
    trafficType: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      model: 0,
      type: "bus"
    };
  },
  created() {
    this.type = this.trafficType;

    if (this.address) {
      if (this.address.bus) {
        this.address.bus = this.address.bus.replaceAll(" ", "&nbsp;");
      }

      if (this.address.subway) {
        this.address.subway = this.address.subway.replaceAll(" ", "&nbsp;");
      }

      if (this.address.parking) {
        this.address.parking = this.address.parking.replaceAll(" ", "&nbsp;");
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
#traffic-modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  padding: 0px;
}

#traffic-modal nav {
  padding-left: 0px;

  display: flex;
  align-items: center;
}
#traffic-modal nav ul {
  display: flex;
  align-items: center;
  /* 가로 스크롤 */
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  padding-left: 0px;
  justify-content: space-between;
}

#traffic-modal nav ul li {
  margin: 0px 10px;

  padding: 10px 0px;
  width: 100px;

  font-family: var(--noto3);
  font-weight: 400;
  font-size: 16px;
  color: #888888;
  width: 56px;
  text-align: center;

  cursor: pointer;
}

#traffic-modal nav ul li.active {
  font-weight: 700;
  font-size: 16px;
  color: #212121;
  border-bottom: 3px solid #907b70;
}
#traffic-modal .modal {
  width: 100%;
  max-width: 360px;
  height: 573px;
  background: #ffffff;
  border-radius: 8px;
  position: fixed;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
  padding: 24px;
  display: flex;
  flex-direction: column;

  font-family: var(--noto3);
}
#traffic-modal .close {
  position: absolute;
  right: 24px;
  bottom: 24px;

  display: flex;
  align-items: center;
  gap: 2px;

  cursor: pointer;
}
#traffic-modal .close span {
  font-family: var(--noto3);
  font-size: 14px;
  font-weight: 500;
  color: #888888;
}
#traffic-modal .modal .title {
  margin-bottom: 24px;
}
#traffic-modal .modal h4 {
  font-weight: 700;
  font-size: 16px;
  color: #666;
}
#traffic-modal .address {
  height: 83px;
  background: #ffffff;

  border: 0.2px solid #888888;
  border-radius: 6px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  margin-bottom: 22px;
}
#traffic-modal .address h5 {
  font-family: var(--obituary-font);

  font-weight: 500;
  font-size: 14px;

  color: #3f3531;
}
#traffic-modal .address p {
  font-family: var(--noto3);
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #666666;

  margin-bottom: 0px !important;
}
#traffic-modal .address .call {
  display: flex;
  align-items: center;
}
#traffic-modal .address .call img {
  width: 13px;
  height: 15px;
}
#traffic-modal .address .call span {
  font-family: var(--noto3);
  font-weight: 400;
  font-size: 10px;
  color: #888888;
}
#traffic-modal .content {
  height: 281px;
  border-top: 0.2px solid #d7d7d7;
  overflow-y: scroll;
  white-space: pre-line;

  padding-top: 20px;

  font-family: var(--noto3);
  font-weight: 400;
  font-size: 14px;

  color: #3f3531;
}
#traffic-modal .modal .icon__wraps {
  display: flex;
  gap: 32px;
  margin-bottom: 16px;
}
#traffic-modal .modal .wreath-card__wraps {
  display: flex;
  gap: 16px;
  flex-direction: column;
  margin-bottom: 16px;
}
</style>
